<p-toast></p-toast>
<div class="app-verification-container">
  <p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
      <!-- <h4>{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h4> -->
      <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
            <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
            <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                class="p-button-help"></button>
            <button (click)="refreshTable()" pButton pRipple label="{{'REFRESH'| translate}}" icon="pi pi-refresh"
                class="p-button-info ml-3"></button>
            <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
        </ng-template>

    </p-toolbar>
      <p-table
        #appVerificationTable
        [value]="tankData"
        [rows]="10"
        [paginator]="true"
        [globalFilterFields]="[
          'srNo',
          'appID',
          'FarmerName',
          'District',
          'Block',
          'Village',
          'Total_Area',
          'AgeOfApplication',
          'Pending_CompletedDays',
          'LandDetail',
          'Status',
          'Status_Ar',

        ]"
        responsiveLayout="scroll"
        [(selection)]="tankData"
        [rowHover]="true"
        dataKey="id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
      >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
            <h5 class="m-0">{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h5>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                    (input)="appVerificationTable.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
            </span>
        </div>
    </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="srNO">
              {{'S_NO'| translate}}
              <p-columnFilter
                type="text"
                field="srNO"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="srNO"></p-sortIcon>
            </th>

            <th pSortableColumn="appID">
              {{'APP_ID'| translate}}
              <p-columnFilter
                type="text"
                field="appID"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="appID"></p-sortIcon>
            </th>

            <th pSortableColumn="FarmerName">
              {{'FARMER_NAME'| translate}}
              <p-columnFilter
                type="text"
                field="FarmerName"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="FarmerName"></p-sortIcon>
            </th>

            <th pSortableColumn="District">
              {{'DISTRICT'| translate}}
              <p-columnFilter
                type="text"
                field="District"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="District"></p-sortIcon>
            </th>

            <th pSortableColumn="Block">
              {{'BLOCK'| translate}}
              <p-columnFilter
                type="text"
                field="Block"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Block"></p-sortIcon>
            </th>

            <th pSortableColumn="Village">
              {{'VILLAGE'| translate}}
              <p-columnFilter
                type="text"
                field="Village"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Village"></p-sortIcon>
            </th>

            <th pSortableColumn="Total_Area">
              {{'TOTAL_AREA'| translate}}
              <p-columnFilter
                type="text"
                field="Total_Area"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Total_Area"></p-sortIcon>
            </th>

            <th pSortableColumn="AgeOfApplication">
              {{'AGE_OF_APPLICATION'| translate}}
              <p-columnFilter
                type="text"
                field="AgeOfApplication"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="AgeOfApplication"></p-sortIcon>
            </th>

            <th pSortableColumn="Pending_CompletedDays">
              {{'PENDING_COMPLETED_DAYS' | translate}}
              <p-columnFilter
                type="text"
                field="Pending_CompletedDays"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Pending_CompletedDays"></p-sortIcon>
            </th>

            <th pSortableColumn="LandDetail">
              {{'LAND_DETAIL'| translate}}
              <p-columnFilter
                type="text"
                field="LandDetail"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="LandDetail"></p-sortIcon>
            </th>

            <th pSortableColumn="Status">
              {{'STATUS'| translate}}
              <p-columnFilter
                type="text"
                field="Status"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Status"></p-sortIcon>
            </th>
            <th pSortableColumn="Status_Ar">
              {{'CURRENT_STATUS'| translate}}
              <p-columnFilter
                type="text"
                field="Status_Ar"
                display="menu"
              ></p-columnFilter>
              <p-sortIcon field="Status_Ar"></p-sortIcon>
            </th>
            <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>

            <th>{{'ACTION'| translate}}</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
          <tr [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(product)}">
            <td>{{ rowIndex + 1 }}</td>
            <td>{{ product.appID }}</td>
            <td>{{ product.FarmerName }}</td>
            <td>{{ product.District }}</td>
            <td>{{ product.Block }}</td>
            <td>{{ product.Village }}</td>
            <td>{{ product.Total_Area }}</td>
            <td>{{ product.AgeOfApplication }}</td>
            <td>{{ product.Pending_CompletedDays }}</td>
            <td>{{ product.LandDetail }}</td>
            <td>{{ product.Status }}</td>
            <td>{{ product.Status_Ar }}</td>
            <td>
              <button
                pButton
                pRipple
                pTooltip="view application"
                icon="pi pi-file"
                class="p-button-rounded p-button-accent mr-1 btnSize"
                (click)="viewFarmerApplication(product)"
              ></button>
            </td>
            <td *ngIf="product?.AppEditableStatus == '1'">
              <button
                (click)="selectTankRowData(product)"
                icon="pi pi-pencil"
                pButton
                pRipple
                type="button"
                class="p-button-rounded p-button-text"
              ></button>
            </td>
            <td *ngIf="product?.AppEditableStatus == '2'">
              <button
                (click)="selectTankRowData(product)"
                icon="pi pi-fw pi-plus"
                pButton
                pRipple
                type="button"
                class="p-button-rounded p-button-text"
              ></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="summary">
          <div class="flex  justify-content-between flex-column ">
              <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tankData ? tankData.length : 0 }} 
                {{'APPLICATION_ADDED'| translate}}.
              </p>
              <div class="flex  justify-content-between flex-column "> 
                  <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_MORE_THAN_TWO_DAYS'| translate}}</div>
                  <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING_BY_ONE_DAY'| translate}}</div>
                  <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APROVED_ON_TIME'| translate}}</div>
                  <div class="flex"><div style="background-color:#ffb3b3 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'DELAYED_APPROVED'| translate}}</div>
              </div>
          </div>
      </ng-template>
      </p-table>
    </div>
  </p-card>
</div>

<p-dialog
  [(visible)]="displayTankDialog"
  [modal]="true"
  [style]="{ width: '80%', height: '100%' }"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  (onHide)="onCloseDialog()"
>
  <div class="app-verification-container">
    <!-- <h4>List Of Water Tank To Be Verified (PFMS Module)</h4> -->
    <div class="col-12">
      <div class="card hidden-xs to-print" id="printableArea" reflow="true">
        <div class="consent-form border">
          <div class="header border">
            <div class="col-3">
              {{'REG_DATE'| translate}} :
              {{ selectedApplication?.dt_Reg | date: "mediumDate" }}
            </div>
            <div class="col-6">
              <h6>
                {{'FARMER_APPLICATION_FORM_FOR_MICRO_IRRIGATION_SCHEME-STAGE3'| translate}}
              </h6>
            </div>
          </div>
          <div class="sub-header">
            <table class="border">
              <tr>
                <td>
                  <p class="head">{{'APPLICATION_NO'| translate}}</p>
                  <p class="bold">{{ selectedApplication?.appID }}</p>
                </td>
                <td>
                  <p class="head">{{'SCHEME_NAME'| translate}}</p>
                  <p class="bold">
                    {{ selectedApplication?.Scheme_Code }}
                  </p>
                </td>
              </tr>
            </table>
          </div>

          <!-- Stage 3 details start -->
          <ng-container>
            <div class="print border bold">
              {{'CALCULATED_POND_VERIFICATION_DETAILS'| translate}}
            </div>
            <div class="table">
              <table class="border">
                <tr>
                  <td>
                    <p class="bold">{{'TYPE_OF_POND'| translate}}</p>
                    <p>{{ pondVerData?.TypeOfPond }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_ESTIMATED_COST'| translate}}</p>
                    <p>
                      {{ pondVerData?.TotalEstimatedCost }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TOTAL_ESTIMATED_SUBSIDY'| translate}}</p>
                    <p>
                      {{ pondVerData?.TotalEstimatedSubsidy }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'STATE_SHARE_AMOUNT'| translate}}</p>
                    <p>{{ pondVerData?.StateShare_Amount }}</p>
                  </td>
                  <td>
                    <p class="bold">{{'CENTER_SHARE_AMOUNT'| translate}}</p>
                    <p>
                      {{ pondVerData?.CenterShare_Amount }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'REMARKS'| translate}}</p>
                    <p>{{ pondVerData?.Remarks }}</p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'TOP_LENGTH'| translate}}</p>
                    <p>
                      {{ pondVerData?.topLength }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_BREADTH'| translate}}</p>
                    <p>
                      {{ pondVerData?.topBreadth }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'BOTTOM_LENGTH'| translate}}</p>
                    <p>
                      {{ pondVerData?.bottomLength }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'BOTTOM_BREADTH'| translate}}</p>
                    <p>
                      {{ pondVerData?.bottomBreadth }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_SIZE'| translate}}</p>
                    <p>
                      {{ pondVerData?.topSize }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TOP_SIZE'| translate}}</p>
                    <p>
                      {{ pondVerData?.topSize }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'DEPTH'| translate}}</p>
                    <p>
                      {{ pondVerData?.depth }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TANK_LAT'| translate}}</p>
                    <p>
                      {{ pondVerData?.tankLat }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'TANK_LONG'| translate}}</p>
                    <p>
                      {{ pondVerData?.tankLng }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'MEASUREMENT_COPY'| translate}}</p>
                    <p>
                      {{ pondVerData?.MeasurementCopy }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'ESTIMATE_COPY_STAGE1'| translate}}</p>
                    <p>
                      {{ pondVerData?.estimateCopy_Stage1 }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_AREA_IS_REQUIRED'| translate}}</p>
                    <p>
                      {{ pondVerData?.AssistancePaidAtStage1 }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_STAGE1'| translate}}</p>
                    <p>
                      {{ pondVerData?.ActualSubsidy_Stage1 }}
                    </p>
                  </td>
                  <td>
                    <p class="bold">{{'ACTUAL_SUBSIDY_STAGE2'| translate}}</p>
                    <p>
                      {{ pondVerData?.ActualSubsidy_Stage2 }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="card dropdown-content" style="margin: 5px">
    <p-toolbar styleClass="mb-4">
      <ng-template pTemplate="left">
        <table>
          <tr>
            <td>
              <p class="bold">{{'ACTUAL_SUBSIDY_STAGE3'| translate}}</p>
              <p>
                <p-inputNumber
                  [(ngModel)]="actualSubsidyStage3" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                  class="mr-3"
                  [ngClass]="{
                    'ng-invalid ng-dirty':
                      isSubmitted && actualSubsidyStage3 == undefined
                  }"
                ></p-inputNumber>
              </p>
              <div
                *ngIf="isSubmitted && actualSubsidyStage3 == undefined"
                class="invalid-feedback"
              >
                <div>{{'ACTUAL_SUBSIDY_AREA_IS_REQUIRED' | translate}}</div>
              </div>
            </td>
          </tr>
        </table>
      </ng-template>
      <ng-template pTemplate="right">
        <p-dropdown
          [options]="items"
          [(ngModel)]="selectedStatus"
          optionLabel="status"
          class="mr-3"
        ></p-dropdown>
        <textarea
          id="description"
          [(ngModel)]="remarks"
          placeholder="Remarks"
          pInputTextarea
          required
          rows="3"
          cols="20"
          class="mr-3"
        ></textarea>
        <button
          pButton
          pRipple
          label="Submit"
          (click)="handleClick()"
          class="p-button-help"
        ></button>
      </ng-template>
    </p-toolbar>
  </div>
</p-dialog>
